<script setup>
const route = useRoute()
const storedService = useLocalStorage('tarc-auth-for-service')
const service = computed(() => {
  if (route.fullPath.includes('theshowportal')) {
    return 'The Show Portal'
  }

  return storedService.value ?? null
})
const logo = computed(() => {
  if (service.value === 'The Show Portal') {
    return '/services/the-show-portal'
  }

  return null
})

watch(service, (value) => {
  storedService.value = value
})
</script>

<template>
  <div
    class="fixed inset-0 grid grid-rows-[auto_1fr] lg:grid-rows-1 lg:grid-cols-2"
  >
    <div
      class="flex items-center justify-center w-full bg-background pt-8 pb-6 lg:justify-end lg:pr-32"
    >
      <div
        v-if="logo"
        class="flex flex-col gap-1 lg:gap-4"
      >
        <picture loading="eager">
          <source
            :srcset="`${logo}.avif`"
            type="image/avif"
          >
          <source
            :srcset="`${logo}.webp`"
            type="image/webp"
          >
          <img
            :src="`${logo}.png`"
            class="block mx-auto h-12 lg:h-auto lg:w-full lg:max-w-80 select-none pointer-events-none"
            :alt="service ? `Logo for ${service}` : 'Service logo'"
            :draggable="false"
          >
        </picture>
        <span
          class="flex items-center w-fit ml-auto text-[10px] lg:text-xs font-bold text-(--ui-text-muted) select-none"
        >
          Powered by&nbsp;
          <TarcLogoText class="inline-block h-1.5 w-10 lg:h-2 lg:w-13.5" />
        </span>
      </div>
      <TarcLogoText
        v-else
        class="block h-8 lg:h-auto lg:w-1/2 lg:max-w-80"
      />
    </div>
    <div class="overflow-y-auto px-4 bg-background">
      <div
        class="flex py-16 justify-center lg:items-center lg:justify-start lg:pl-16 lg:min-h-screen"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
